import { combineReducers } from '@reduxjs/toolkit';

import { clientFormOptionsApi } from '~lookups/actions/clientFormOptions';
import { clientInvoiceStatusesApi } from '~lookups/actions/clientInvoiceStatuses';
import { eventsApi } from '~lookups/actions/events';
import { fundingLevelAmountsApi } from '~lookups/actions/fundingLevelAmounts';
import { invoiceStatusesApi } from '~lookups/actions/invoiceStatuses';
import { sahClaimStatusesApi } from '~lookups/actions/sahClaimStatuses';
import { sahServiceHptsApi } from '~lookups/actions/sahServiceHpts';
import { sahServiceItemsApi } from '~lookups/actions/sahServiceItems';
import { sahServicesApi } from '~lookups/actions/sahServices';
import { sahServiceWrapsApi } from '~lookups/actions/sahServiceWraps';
import { settingsApi } from '~lookups/actions/settings';
import { supplementsLookupApi } from '~lookups/actions/supplements';

import addressLookup from './addressLookup';
import calendarFrequencies from './calendarFrequencies';
import clientFormOptions from './clientFormOptions';
import equipments from './equipments';
import invoiceStatuses from './invoiceStatuses';
import leaveCodes from './leaveCodes';
import leaveRequests from './leaveRequests';
import medications from './medications';
import ndisSupportItems from './ndisSupportItems';
import paymentTypes from './paymentTypes';
import regions from './regions';
import sahCategories from './sahCategories';
import serviceBranches from './serviceBranches';
import shifts from './shifts';
import statementDeliveryPreferences from './statementDeliveryPreferences';
import statementStatuses from './statementStatuses';
import states from './states';
import taskClassifications from './taskClassifications';
import taskTypes from './taskTypes';
import userLanguages from './userLanguages';
import workSites from './workSites';

export const lookups = {
  addressLookup,
  calendarFrequencies,
  clientFormOptions,
  equipments,
  invoiceStatuses,
  statementStatuses,
  statementDeliveryPreferences,
  leaveCodes,
  leaveRequests,
  medications,
  ndisSupportItems,
  paymentTypes,
  regions,
  sahCategories,
  serviceBranches,
  shifts,
  states,
  taskClassifications,
  userLanguages,
  taskTypes,
  workSites,
};

export default combineReducers(lookups);
export const lookupApis = [
  clientFormOptionsApi,
  clientInvoiceStatusesApi,
  eventsApi,
  fundingLevelAmountsApi,
  invoiceStatusesApi,
  sahClaimStatusesApi,
  sahServicesApi,
  sahServiceItemsApi,
  sahServiceWrapsApi,
  sahServiceHptsApi,
  settingsApi,
  supplementsLookupApi,
];
